module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/common_btn_bg03-c7837a2e74ca8dc7d3f1662991f89829.png";